export const HABILITADO = 'Habilitado';

export const IS_ROOT = 'IsRoot';

export const ORDENACAO = 'Ordenacao';

export const ICONE = 'Icone';

export const PUBLICO = 'Publico'
